import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
} from './style';

import AppState from '../../states/AppState';

class NavUpdater extends Component {
  componentDidMount() {
    window.addEventListener('scroll', this.updateNav);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateNav);
  }

  updateNav = () => {
    if (!this.wrapper) return;
    if (this.wrapper.getBoundingClientRect().top < 0 && this.wrapper.getBoundingClientRect().bottom > 0) {
      AppState.activeNavItemIndex = this.props.navItemIndex;
    }
  }

  render() {    
    return (
      <Wrapper
        innerRef={(el) => {
          if (!this.wrapper) {
            this.wrapper = el;
            this.updateNav();
          }
        }}
      >{this.props.children}</Wrapper>
    );
  }
};

export default observer(NavUpdater);



// WEBPACK FOOTER //
// ./src/components/NavUpdater/index.js